import {NgModule} from '@angular/core';
import {AuthGuard, ComponentDeactivateGuardService} from 'common-domain';
import {SignUpComponent} from "./home/sign-up/sign-up.component";
import {ErrorPageComponent} from 'common-domain';
import {LoadingPageComponent} from './home/loading-page/loading-page.component';
import {Router, RouterModule, Routes} from "@angular/router";
import {HomeComponent} from "./home/home.component";

export const PATH_CONSTANTS = {
  SLASH: '/',
  USER: 'user',
  HOME: 'home'
};


const routes: Routes = [
  {
    path: 'signup/:token',
    component: SignUpComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    canActivate: [AuthGuard],
  },
  // Lazy loading modules
  // {path: 'domain', loadChildren: 'domain/domain.module#CommonDomainModule'},
  {
    path: PATH_CONSTANTS.USER,
    canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.errorHandler = (error: any) => {
      this.router.navigateByUrl(PATH_CONSTANTS.SLASH + PATH_CONSTANTS.HOME);
    };
  }
}
